import "../Surveys.css";

//react
import { useState, useEffect } from "react";

//components
import Argentina from "./Argentina";
import Brazil from "./Brazil";
import Mexico from "./Mexico";
import Colombia from "./Colombia";
import Peru from "./Peru";
import Chile from "./Chile";
import CostaRica from "./CostaRica";
import Ecuador from "./Ecuador";
import StyledSelect from "../../reusable/StyledSelect";

//hooks
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//assets
import TEXT from "../../../utils/text/surveys_national.json";

const countries = [
  { code: "ARG", label: "Argentina" },
  { code: "BRA", label: "Brasil" },
  { code: "CHI", label: "Chile" },
  { code: "COL", label: "Colombia" },
  { code: "CRI", label: "Costa Rica" },
  { code: "ECU", label: "Ecuador" },
  { code: "MEX", label: "México" },
  { code: "PER", label: "Perú" },
];

const countriesEn = [
  { code: "ARG", label: "Argentina" },
  { code: "BRA", label: "Brazil" },
  { code: "CHI", label: "Chile" },
  { code: "COL", label: "Colombia" },
  { code: "CRI", label: "Costa Rica" },
  { code: "ECU", label: "Ecuador" },
  { code: "MEX", label: "Mexico" },
  { code: "PER", label: "Peru" },
];

export default function National() {
  //language
  const { language } = useCurrentLanguage();

  //useState - country
  const [country, setCountry] = useState("CHI");

  //useState - survey
  const [survey, setSurvey] = useState("");

  //useState - surveys
  const [surveys, setSurveys] = useState([]);

  //useEffect
  useEffect(() => {
    setupSurveys(country);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //setup surveys
  const setupSurveys = (id) => {
    let tempSurveys = [],
      tempSurveysOptions = [];
    Object.keys(TEXT[id]).forEach((item) => {
      let sur = TEXT[id][item]["survey"][language];
      if (!tempSurveys.includes(sur)) {
        tempSurveys.push(sur);
        tempSurveysOptions.push({ code: sur, label: sur });
      }
    });
    console.log(tempSurveys);
    setSurvey(tempSurveysOptions[0].code);
    setSurveys(tempSurveysOptions);
  };

  //handle country change
  const handleCountryChange = (value) => {
    setCountry(value);
    setupSurveys(value);
  };

  //handle survey change
  const handleSurveyChange = (value) => {
    setSurvey(value);
  };

  return (
    <div className="surveys-page-content">
      <div className="surveys-page-graphs">
        <div className="survey-page-full-surveys">
          <div className="full-screen">
            <div className="nl-selector-container">
              <StyledSelect
                selectedValue={country}
                changeHandler={handleCountryChange}
                options={language === "es" ? countries : countriesEn}
                placeHolderText={"Selecciona un país"}
                labelAttributeName={"label"}
                valueAttributeName={"code"}
                ignoreTranslation={true}
                language={language}
                isDisabled={false}
              />
              <StyledSelect
                selectedValue={survey}
                changeHandler={handleSurveyChange}
                options={surveys}
                placeHolderText={"Selecciona una encuesta"}
                labelAttributeName={"label"}
                valueAttributeName={"code"}
                ignoreTranslation={true}
                language={language}
                isDisabled={false}
              />
            </div>
            {country === "ARG" ? (
              <Argentina survey={survey} />
            ) : country === "BRA" ? (
              <Brazil survey={survey} />
            ) : country === "CHI" ? (
              <Chile survey={survey} />
            ) : country === "COL" ? (
              <Colombia survey={survey} />
            ) : country === "CRI" ? (
              <CostaRica survey={survey} />
            ) : country === "ECU" ? (
              <Ecuador survey={survey} />
            ) : country === "MEX" ? (
              <Mexico survey={survey} />
            ) : (
              <Peru survey={survey} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
